import React , { useState , useEffect } from 'react'
import * as CONSTANTS from '../../utils/CONSTANTS'
import { makeSideBarActive } from '../../utils/EllowUtils'
import Table from "../../components/table"
import { TabStrip } from "@progress/kendo-react-layout";
import Tab from "../../components/tab";
import {
  TabStripSelectEventArguments,
  TabStripTab,
} from "@progress/kendo-react-layout";

function CompanyTab(props: any) {

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 3) 
  const [data, setData] = useState<any>([])
  const [total, setTotal] = useState<number>()
  const [selected, setSelected] = useState<number>(0)
  const [hirerTotal, setHirerTotal] = useState<any>()
  const [providerTotal, setProviderTotal] = useState<any>()

  useEffect(() => { 
    if(props.positions){
      setData(props && props.positions &&  props.positions)
    }
  }, [props.positions, props.hirerTotal, props.providerTotal])

  const pageChange = (data: any) => {
    
  }

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  }

  const pageSize = (pageSize: any, pageNumber: number) => {
    
    props.pageSize(pageSize, pageNumber);
    
  }

  return (
    <section className="tableStyle">
       <TabStrip selected={selected} onSelect={handleSelect}>
          <Tab title={'Hirer Companies'} >
          <Table  setSort={props.setSort}     applySort={props.applySort}  getTablesValues={''} pageSize={pageSize} data={props.hirerCompanies} rowClick={''} total={props.hirerTotal} pageChange={pageChange} type={'registrationApproval'} approveOrRejectCustomer={props.approveOrRejectCustomer}/>
          </Tab>
          <Tab title={'Provider Companies'} >
          <Table  setSort={props.setSort}     applySort={props.applySort}  getTablesValues={''} pageSize={pageSize} data={props.providerCompanies} rowClick={''} total={props.providerTotal} pageChange={pageChange} type={'providertable'} approveOrRejectCustomer={props.approveOrRejectCustomer}/>
          </Tab>
      </TabStrip>
    </section>
  )
}

export default CompanyTab